import React, { useEffect, useState } from 'react';
import { useLang } from '../contexts/LanguageContext';

const LOGO_URL = '/desertnimbus-logo.png';

const Header = () => {
  const { lang, t, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('home');

  const navItems = [
    { id: 'home', label: t.nav.home },
    { id: 'technology', label: t.nav.technology },
    { id: 'solutions', label: t.nav.solutions },
    { id: 'about', label: t.nav.about },
    { id: 'contact', label: t.nav.contact },
  ];

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const sections = ['home', 'about', 'technology', 'solutions', 'contact'];
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el) {
          const r = el.getBoundingClientRect();
          if (r.top <= 200 && r.bottom >= 200) { setActive(id); break; }
        }
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#0a1220]/90 backdrop-blur-xl border-b border-cream/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-3 flex items-center justify-between gap-6">
        {/* Logo - uploaded brand mark */}
        <a href="#home" className="flex items-center gap-3 group shrink-0">
          <img
            src={LOGO_URL}
            alt="DesertNimbus Technologies"
            className="h-28 md:h-32 lg:h-36 xl:h-40 w-auto object-contain"
            style={{ filter: 'drop-shadow(0 6px 22px rgba(201, 154, 61, 0.3))' }}
          />
        </a>

        {/* Nav */}
        <nav className="hidden lg:flex items-center gap-7">          {navItems.map((n) => {
            const isActive = active === n.id;
            return (
              <a
                key={n.id}
                href={`#${n.id}`}
                className={`nav-link font-mono text-[12px] tracking-[0.3em] transition-colors ${
                  isActive ? 'text-[#c99a3d] active' : 'text-cream/75 hover:text-cream'
                }`}
              >
                {n.label.toUpperCase()}
              </a>
            );
          })}
        </nav>

        {/* Lang toggle */}
        <div className="flex items-center gap-1 border border-cream/20 rounded-full px-2 py-1">
          <button
            onClick={() => setLang('en')}
            className={`font-mono text-[11px] tracking-[0.2em] px-3 py-1.5 rounded-full transition-all ${
              lang === 'en' ? 'bg-[#c99a3d] text-[#0a1220]' : 'text-cream/70 hover:text-cream'
            }`}
          >
            EN
          </button>
          <button
            onClick={() => setLang('ar')}
            className={`text-[14px] px-3 py-1 rounded-full transition-all ${
              lang === 'ar' ? 'bg-[#c99a3d] text-[#0a1220]' : 'text-cream/70 hover:text-cream'
            }`}
            style={{ fontFamily: "'Fraunces', serif" }}
          >
            العربية
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
